import { useFormHandler } from ".";
import { useI18n } from "../contexts";
import { EServiceTemplateDataProcessingInCountriesSpecialTreatment } from "@devowl-wp/api-real-cookie-banner";
function useFormTcfVendorHandler(opts) {
    const { __ } = useI18n();
    const { attributes, template, vendor, declarations, isEdit } = opts;
    const defaultValues = {
        status: "publish",
        restrictivePurposes: {
            normal: {}
        },
        dataProcessingInCountries: [],
        dataProcessingInCountriesSpecialTreatments: [],
        templateCheck: false,
        ...attributes || {}
    };
    if (vendor && declarations) {
        for (const purpose of [
            ...vendor.legIntPurposes,
            ...vendor.purposes
        ].filter(Boolean)){
            defaultValues.restrictivePurposes.normal[purpose.toString()] = {
                enabled: true,
                legInt: vendor.legIntPurposes.indexOf(purpose) > -1 && vendor.specialPurposes.indexOf(purpose) === -1 ? "yes" : "no"
            };
        }
    }
    const handlers = useFormHandler({
        ...opts,
        handleSave: async (values)=>{
            // At least one purpose must be active
            const enabledPurposes = Object.values(values.restrictivePurposes.normal).filter((param)=>{
                let { enabled } = param;
                return enabled;
            }).length + vendor.specialPurposes.length;
            if (enabledPurposes === 0) {
                throw __("You need to enable at least one purpose!");
            }
            return await opts.handleSave(values);
        },
        defaultValues,
        i18n: {
            successMessage: __("You have successfully saved the TCF vendor configuration."),
            validationError: __("The TCF vendor configuration could not be saved due to missing/invalid form values."),
            unloadConfirm: __("You have unsaved changes. If you leave this page, your changes will be discarded.")
        }
    });
    // TCF supports also Standard Contractual clauses, so we need to force to use the SCCs and the user should not be able to uncheck it
    const overrideValues = (initialValues)=>{
        var _vendor_additionalInformation_transferMechanisms, _vendor_additionalInformation;
        if ((vendor == null ? void 0 : (_vendor_additionalInformation = vendor.additionalInformation) == null ? void 0 : (_vendor_additionalInformation_transferMechanisms = _vendor_additionalInformation.transferMechanisms) == null ? void 0 : _vendor_additionalInformation_transferMechanisms.indexOf("SCCs")) > -1) {
            initialValues.dataProcessingInCountriesSpecialTreatments.push(EServiceTemplateDataProcessingInCountriesSpecialTreatment.StandardContractualClauses);
        }
        return initialValues;
    };
    return {
        ...handlers,
        defaultValues,
        overrideValues,
        contextValue: {
            isEdit,
            vendor,
            declarations,
            defaultTemplateValues: template ? defaultValues : {}
        }
    };
}
export { useFormTcfVendorHandler };
